/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Notice_Parq_ClearanceInputs */

const en_us2_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two or more of your health answers suggest talking to a doctor before you start. Your plan begins gently.`)
};

const pt_br2_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas ou mais respostas de saúde sugerem conversar com um médico antes de começar. Seu plano começa com calma.`)
};

const es_419_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos o más de tus respuestas de salud sugieren hablar con un médico antes de empezar. Tu plan empieza con calma.`)
};

const pt_pt2_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas ou mais respostas de saúde sugerem falar com um médico antes de começares. O teu plano começa com calma.`)
};

const fr_fr2_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Au moins deux de tes réponses de santé suggèrent de consulter un médecin avant de commencer. Ton programme démarre en douceur.`)
};

const de_de2_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei oder mehr deiner Gesundheitsantworten sprechen dafür, vor dem Start mit einem Arzt zu reden. Dein Plan beginnt sanft.`)
};

const it_it2_prescription_notice_parq_clearance = /** @type {(inputs: Prescription_Notice_Parq_ClearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due o più delle tue risposte sulla salute suggeriscono di parlare con un medico prima di iniziare. La tua scheda parte in modo graduale.`)
};

/**
* | output |
* | --- |
* | "Two or more of your health answers suggest talking to a doctor before you start. Your plan begins gently." |
*
* @param {Prescription_Notice_Parq_ClearanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_parq_clearance = /** @type {((inputs?: Prescription_Notice_Parq_ClearanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Parq_ClearanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_parq_clearance(inputs)
	if (locale === "es-419") return es_419_prescription_notice_parq_clearance(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_parq_clearance(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_parq_clearance(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_parq_clearance(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_parq_clearance(inputs)
	return en_us2_prescription_notice_parq_clearance(inputs)
});
export { prescription_notice_parq_clearance as "prescription.notice.parq_clearance" }